import {LayoutEnum} from "@/enums/LayoutEnum"

class SearchEvent {
    event: string = 'search_module'
    search_engine_name: string = "V1"
    search_event: string // 1st input - format string ->> Example : Val Thorens
    search_begin_date: string // 2nd input - format string ->> Example : "27/07/2023"
    search_end_date: string // 3rd input - format string ->> Example : "08/08/2023"
    search_capacity: string // 4th input - format string ->> Example : "4"
    search_package: string[] // 5th input - format array ->> Example : "['Hébergement seul', ..., 'Hébergement seul + Skipass']"
    search_lodging_type: string[] // 6th input - format array ->> Example : "['Résidence de tourisme', ..., 'Chalet']"
    search_engine_version: LayoutEnum
    constructor(event: {
        search_event: string
        search_begin_date: string
        search_end_date: string
        search_capacity: string
        search_package: string[]
        search_lodging_type: string[]
        search_engine_version: LayoutEnum
    }) {
        this.search_event = event.search_event
        this.search_begin_date = event.search_begin_date
        this.search_end_date = event.search_end_date
        this.search_capacity = event.search_capacity
        this.search_package = event.search_package
        this.search_lodging_type = event.search_lodging_type
        this.search_engine_version = event.search_engine_version
    }
}

export default SearchEvent
